export const CONTENT_TYPES = {
  text: 'text',
  heading: 'heading',
  wrapper: 'wrapper',
  table: 'table',
};

export const stages = [
  {
    stageId: 1,
    title: 'Emergent',
    items: [
      {
        collectionId: '3456',
        title: 'Emergent A',
      },
      {
        collectionId: '56789',
        title: 'Emergent B',
      },
    ],
  },
  {
    stageId: 2,
    title: 'Early',
    items: [
      {
        collectionId: '123',
        title: 'Early A',
      },
      {
        collectionId: '124',
        title: 'Early B',
      },
    ],
  },
  {
    stageId: 3,
    title: 'Developing',
    items: [
      {
        collectionId: '7891029485',
        title: 'Developing A',
      },
    ],
  },
];
